export default function ComparisonChecklist() {
  const checklistItems = [
    {
      category: 'Licensing & Credentials',
      items: [
        'Valid Texas Master Plumber License',
        'Current liability insurance',
        'Workers compensation coverage',
        'BBB accreditation and rating',
        'Manufacturer certifications'
      ]
    },
    {
      category: 'Experience & Expertise',
      items: [
        'Years in business in El Paso',
        'Specialization in your project type',
        'Experience with local building codes',
        'Emergency service availability',
        'Commercial vs residential focus'
      ]
    },
    {
      category: 'Pricing & Estimates',
      items: [
        'Free written estimates',
        'Detailed breakdown of costs',
        'Transparent pricing structure',
        'Payment terms and options',
        'Warranty on parts and labor'
      ]
    },
    {
      category: 'Reputation & Reviews',
      items: [
        'Online reviews and ratings',
        'Local references available',
        'Portfolio of completed projects',
        'Response time to inquiries',
        'Customer service quality'
      ]
    }
  ];

  return (
    <section id="checklist" className="py-20 px-6 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Plumber Comparison Checklist
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Use this comprehensive checklist to evaluate and compare plumbing contractors in El Paso. Make an informed decision for your plumbing project.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {checklistItems.map((section, index) => (
            <div key={index} className="bg-white rounded-xl p-8 border-2 border-gray-200 hover:border-blue-500 transition-all">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 flex items-center justify-center bg-blue-100 rounded-lg">
                  <i className="ri-checkbox-circle-line text-2xl text-blue-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900">{section.category}</h3>
              </div>
              <ul className="space-y-3">
                {section.items.map((item, idx) => (
                  <li key={idx} className="flex items-start gap-3">
                    <i className="ri-check-line text-blue-600 mt-1 flex-shrink-0"></i>
                    <span className="text-gray-700">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 bg-blue-600 rounded-xl p-8 text-white">
          <div className="max-w-3xl mx-auto text-center">
            <h3 className="text-2xl font-bold mb-4">Red Flags to Watch For</h3>
            <div className="grid md:grid-cols-3 gap-6 text-left">
              <div className="flex items-start gap-3">
                <i className="ri-alert-line text-2xl flex-shrink-0"></i>
                <div>
                  <strong className="block mb-1">No License</strong>
                  <p className="text-sm text-white/90">Always verify valid plumbing license</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-alert-line text-2xl flex-shrink-0"></i>
                <div>
                  <strong className="block mb-1">Cash Only</strong>
                  <p className="text-sm text-white/90">Legitimate contractors accept multiple payment methods</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-alert-line text-2xl flex-shrink-0"></i>
                <div>
                  <strong className="block mb-1">No Written Estimate</strong>
                  <p className="text-sm text-white/90">Always get detailed written quotes</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
